import { Autocomplete, TextField } from '@mui/material';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ImportExcelColumnMapping from '../../components/ImportExcelColumnMapping';
import { SHOW_SNACKBAR } from '../../utils/types';
import { importContactExcel } from '../../store/actions/tenantAction';

function ImportLiveChatContact({ setShow, categories, setSelectedCategories, selectedCategories, onSearch }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const globalReducer = useSelector((state) => state.globalReducer);
    const [columns, setColumns] = useState({ "whatsappNumber": "", "name": "", "email": "", "customerId": "", "gender": "", "location": "", "messageType": "", "lastMessage": "", "lastMessageDate": "" });

    return (
        <div className="height30 flex flex-col justify-between pb-3">
            <div className="h-dvh overflow-y-auto p-4 customPadding">
                <div className="w-full h-10 mt-2 mb-4">
                    <Autocomplete
                        multiple={true}
                        aria-required={true}
                        options={categories}
                        isOptionEqualToValue={(option, value) =>
                            option?.categoryName === value?.categoryName
                        }
                        getOptionLabel={(option) => option?.categoryName ?? ""}
                        onChange={(e, value) => {
                            setSelectedCategories(value);
                        }}
                        sx={{
                            "& .MuiAutocomplete-inputRoot": {
                                padding: "0px",
                            },
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder={t("Select Category")}
                                className="custom-input"
                                sx={{
                                    "& .MuiInputBase-root": {
                                        padding: "0px",
                                        "&.Mui-focused fieldset": {
                                            borderColor: "none",
                                            border: "0px",
                                        },
                                        fontSize: "14px",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "#FFFFFF",
                                        "& fieldset": {
                                            borderColor: "#ccc",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#888",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#1976d2",
                                        },
                                    },
                                }}
                            />
                        )}
                    />
                </div>
                <ImportExcelColumnMapping setColumns={setColumns}
                    setIsShow={setShow}
                    columns={columns}
                    onImportClick={(con) => {
                        const categories = selectedCategories?.map((c) => c.categoryName) ?? [];
                        if (!categories || categories?.length <= 0) {
                            dispatch({ type: SHOW_SNACKBAR, payload: { type: "error", message: "Please select category", open: true } });
                            return;
                        }
                        dispatch(
                            importContactExcel({
                                excelUploadedPath: con.excelUploadedPath,
                                columns: { ...con.columns, category: categories[0] },
                                tenantId: globalReducer.loginInfo.tenantId,
                                wabaId: globalReducer.waba?.id,
                            }, (a) => {
                                setTimeout(() => onSearch(), 300);
                                setShow(false);
                            })
                        );
                    }}
                />
            </div>
        </div>
    )
}

export default ImportLiveChatContact